// src/wiring/telemetry/report.ts
//
// Minimal telemetry hook used by manifests.
// - In dev: console.debug
// - In prod: can be swapped to OTel/Sentry/metrics sink later
//
// IMPORTANT: Do not attach raw payloads here (PII / sensitive).
//

export type TelemetryEventName =
  | "capability.blocked"
  | "capability.installed"
  | "capability.install_failed"
  | "capability.metric"
  | "capability.skipped"
  | "capability.uninstalled"
  | "capability.warn"
  | "wiring.capability_install_failed"
  | "wiring.capability_installed"
  | "wiring.install_done"
  | "wiring.install_skipped"
  | "wiring.install_start"
  | "wiring.uninstalled";

export function report(
  name: TelemetryEventName,
  fields: Record<string, unknown>,
): void {
  try {
    // Keep it structured; do not include raw event payloads.
    const msg = { name, ts: Date.now(), ...fields };

    // Allow a global sink override (future: OTel exporter, Sentry, etc.)
    const w = window as any;
    if (typeof w.__synk_report === "function") {
      w.__synk_report(msg);
      return;
    }

    // Default dev-friendly sink
    // eslint-disable-next-line no-console
    console.debug("[synktribe]", msg);
  } catch {
    // never throw from telemetry
  }
}
